import {MuWidget} from "mu-widget/lib/MuWidget";
import {BaseModule} from "./BaseModule";

export abstract class BaseFilter extends MuWidget<BaseModule>
{
	afterIndex() {
		this.muBindData(this.muParent.getFilter());
	}

	showByField(field: string|null): HTMLElement[] {
		const res = [];
		// @ts-ignore
		for(const el of this.ui.searchFields.children) {
			const vis = !field || (field == el.dataset.field);
			el.style.display = vis
				? ""
				: "none";
			if (vis) res.push(el);
		}
		this.muVisible(!field, 'bClearFilter');

		return res;
	}

	bFilter_click() {
		this.muParent.setFilter(this.muFetchData());
		this.muRemoveSelf();
	}

	bClearFilter_click() {
		this.muParent.setFilter({});
		this.muRemoveSelf();
	}

	eraseFilterField(ev: any, field: string) {
		this.muBindData({ [field]: null });
	}
}
